import { useContext } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { useQueryClient } from "react-query"
import SeoContainer from "~/components/Seo/SeoContainer"
import UnsavedChanges from "~/components/Seo/UnsavedChanges"
import { SEO_SCHEMA } from "~/constants/seo"
import PathContext from "~/contexts/Path"
import useSetSeoMutation from "~/hooks/useSetSeoMutation"
import useYupValidationResolver from "~/hooks/useYupValidationResolver"

const seoSchema = SEO_SCHEMA

const Seo = ({ routes = [], ...rest }) => {
  const { path } = useContext(PathContext)
  const queryClient = useQueryClient()
  const { mutateAsync, isLoading } = useSetSeoMutation({
    type: "badge",
    type_id: path.id,
  })

  const resolver = useYupValidationResolver(seoSchema)
  const methods = useForm({
    resolver,
    defaultValues: {
      title: path?.seo?.title || "",
      description: path?.seo?.description || "",
      image: path?.seo?.image || {},
    },
  })

  const onSubmitHandler = async (data) => {
    await mutateAsync(data, methods.reset).then((res) => {
      methods.reset({
        title: res.title ?? "",
        description: res.description ?? "",
        image: res.image ?? "",
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <SeoContainer onSubmitHandler={methods.handleSubmit(onSubmitHandler)} />
      <UnsavedChanges
        onSubmitHandler={methods.handleSubmit(onSubmitHandler)}
        isLoading={isLoading ?? false}
      />
    </FormProvider>
  )
}

export default Seo
